module.exports = __webpack_public_path__ + "img/logoEn.6cdeac9c.png";